import axios from 'axios';

/** Track member activity on click * */
const trackClick = async (elementId, uri, skipRedirect = false) => {
    const url = '/actions/reporting/log';
    const pos = elementId.indexOf('_');
    elementId = pos > 0 ? elementId.substring(0, pos) : elementId;

    const data = {
        id: elementId,
        CRAFT_CSRF_TOKEN: csrfTokenValue,
    };

    try {
        await axios.post(url, data).then();
    } catch (error) {
        console.log(error);
    } finally {
        if (!skipRedirect) {
            window.location.replace(uri);
        }
    }
};

export { trackClick };
